/** @jsxImportSource @emotion/react */
import React, {useEffect, useState} from 'react'
import {Table, Thead, Tbody, Tr, Th, Td, Flex, Text,} from '@chakra-ui/react'
import styles from '../styles'
import {Link} from "react-router-dom";
import {Box} from "@material-ui/core";
import {ReactComponent as Unfinished} from "../../../assets/unfinishedIconca.svg";
import {ReactComponent as Ready} from "../../../assets/ready.svg";

const Cost = ({project, history, reports}) => {
    const [minPrice, setMinPrice] = useState()
    const [minPrice5, setMinPrice5] = useState()

    useEffect(() => {
        if (!reports) return
        let prices = []
        let prices5 = []
        for (let i = 0; i < reports?.length; i++) {
            prices.push(Number(reports[i].costYear?.replace(',', '')))
            prices5.push(5 * Number(reports[i].costYear?.replace(',', '')))
        }
        let min = Math.min(...prices)
        let min5 = Math.min(...prices5)
        setMinPrice(min)
        setMinPrice5(min5)
    }, [reports])

    return (
        <>
            <Table
                css={styles.table}
                variant="simple">
                <Thead>
                    <Tr css={styles.tr}>
                        <Th>Rank</Th>
                        <Th>Report</Th>
                        <Th>Cost/Year</Th>
                        <Th>Cost Above Lowest/Year</Th>
                        <Th>Cost Above Lowest(5 yr)</Th>
                        <Th>Payback(yrs)</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {
                        reports?.length > 0 ? reports?.sort((a: any,b: any) => Number(a?.costYear?.replace(',','')) - Number(b?.costYear?.replace(',','')))?.map((item, idx) => (
                            <Tr
                                key={item.id}
                                css={styles.tr}
                                bg="white.100"
                                boxShadow="2px 4px 10px rgba(0, 0, 0, 0.25)"
                                onClick={() => history.push(`/projects/proposal/${encodeURIComponent(item.proposalName)}/${project.id}/${item.id}`)}>
                                <Td>
                                    <Text as='span'  float='left'>
                                        {idx + 1}
                                    </Text>
                                    <Box ml={5}>
                                        {
                                            item.status === 'Unfinished' ? (
                                                <Unfinished/>
                                            ) : (
                                                <Ready/>
                                            )
                                        }
                                    </Box>
                                </Td>
                                <Td>
                                    {item.proposalName ? `${item.proposalName}` : '-'}
                                </Td>
                                <Td>
                                    {item.costYear ? `$${Number(item.costYear).toLocaleString('en-US')}` : '$0'}
                                </Td>
                                <Td>
                                    {minPrice ? `$${(Number(item.costYear?.replace(',', '')) - minPrice).toLocaleString('en-US')}` : '$0'}
                                </Td>
                                <Td>
                                    {minPrice5 ? `$${(Number(item.costYear?.replace(',', '')) * 5 - minPrice5).toLocaleString('en-US')}` : '$0'}
                                </Td>
                                <Td>
                                    {item.payback ? `${Number(item.payback)?.toFixed(3)}` : '0'}
                                </Td>
                            </Tr>
                        )) : (
                            <Tr>
                                <Td
                                    colSpan='7'>
                                    <Flex
                                        border='3px solid #8FCF74'
                                        p={14}
                                        mx={14}
                                        borderRadius='10px'>
                                        <Text>
                                            Looks like you don’t have any proposals yet... Click the orange Edit Details
                                            button to
                                            add
                                            more property information or <Link to="/contact">
                                            <Text as='span' textDecoration='underline'>click here</Text></Link>
                                            <Text as='span'> to contact your Energy Consultant.</Text>
                                        </Text>
                                    </Flex>
                                </Td>
                            </Tr>
                        )
                    }
                </Tbody>
            </Table>
        </>
    )
}

export default Cost
